export default __webpack_public_path__ + "static/media/warning-circle-caixa.bf82612c.svg";